export default __webpack_public_path__ + "static/media/participante-home.fbe743a9.png";